import React from 'react';
import { FaClipboardCheck } from 'react-icons/fa';

const InterviewEvaluation = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center p-8">
      <FaClipboardCheck className="text-6xl text-gray-400 mb-6" />
      <h1 className="text-3xl font-bold text-gray-800 mb-4">Interview Evaluation</h1>
      <p className="text-xl text-gray-600 max-w-2xl">
        Our interview evaluation system is coming soon. This will help you standardize the interview process, track candidate performance, and make data-driven hiring decisions.
      </p>
    </div>
  );
};

export default InterviewEvaluation; 